import SIRET from 'services/SIRET/index';


//CLIENTS

export const getSiret = (siret) => SIRET.get(`/etablissements/${siret}`);